import React from "react";

const C = { ink: "var(--pr-ink)", ink2: "var(--pr-ink2)", muted: "var(--pr-muted)", line: "var(--pr-line)", gold: "var(--pr-gold)" };

export const RacerBadges = ({ badges, cleared }) => {
  if (!badges?.length) return null;
  const earned = badges.filter((b) => b.earned);
  const next = badges.find((b) => !b.earned);
  if (!earned.length && !cleared) return null;
  return (
    <div className="rounded-2xl p-5 lg:p-6 pr-card" data-testid="caddy-badges-card">
      <p className="text-[10px] font-bold uppercase tracking-widest mb-2" style={{ color: C.muted }}>🏅 Racer badges</p>
      {earned.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {earned.map((b) => (
            <span
              key={b.id}
              className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-bold"
              style={{ background: "var(--pr-tint-gold)", color: C.ink }}
              title={`${b.threshold} relays cleared`}
              data-testid={`badge-${b.id}`}
            >
              {b.emoji} {b.label}
            </span>
          ))}
        </div>
      )}
      {next ? (
        <div data-testid="badge-next">
          <p className="text-[11px] mb-1" style={{ color: C.ink2 }}>
            Next: <b style={{ color: C.ink }}>{next.emoji} {next.label}</b> at {next.threshold} cleared, {Math.max(next.threshold - (cleared || 0), 0)} to go
          </p>
          <div className="h-1.5 rounded-full overflow-hidden" style={{ background: C.line }}>
            <div className="h-full rounded-full transition-all" style={{ width: `${Math.min(((cleared || 0) / next.threshold) * 100, 100)}%`, background: "var(--pr-gold)" }} />
          </div>
        </div>
      ) : (
        <p className="text-[11px]" style={{ color: C.ink2 }}>Every badge earned, a full year of showing up. 🏆</p>
      )}
    </div>
  );
};
